<template>
  <div class="induction">
    <h3 v-if="cmCopy !== ''">{{ cmCopy.title }}</h3>
    <p v-if="cmCopy !== ''" v-html="cmCopy.description "></p>
    <div class="induction-group">
      <h3>3 Letter Airport Codes (City code in brackets if different)</h3>
      <div class="airport-codes">
        <div v-for="(region, index) in airportCodes" :key="region.title + '-' + index">
          <h4 class="my-3">{{ region.title }}</h4>
          <div v-for="(cityCode, index) in region.codes" :key="cityCode.code + '-' + index" class="airport-codes-item">
            <p class="highlight-text">{{cityCode.code}}</p>
            <p>{{ cityCode.city }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="induction-group">
      <h3 class="mb-5">Airline Codes (HUB city where they are based)</h3>
      <div class="airport-codes">
        <div v-for="(airline, index) in airlineCodes" :key="airline.title + '-' + index" class="d-flex align-items-center">
          <p class="mr-3 highlight-text">{{ airline.code }}</p>
          <p>{{ airline.airline }}</p>
        </div>
      </div>
      <p class="highlight-text">*American carriers have multiple hubs</p>
    </div>
    <div class="induction-group">
      <h3 class="mb-5">Phonetic Alphabet</h3>
      <div class="airport-codes-alt">
        <div v-for="(code, index) in phonetic" :key="phonetic.code + '-' + index" class="d-flex align-items-center">
          <p>{{ code.code }}</p>
        </div>
      </div>
    </div>
    <div class="induction-group">
      <h3 class="mb-5">Glossary</h3>
      <div>
        <div v-for="(term, index) in glossary" :key="term.term + '-' + index" class="glossary">
          <p class="highlight-text">{{ term.term }}</p>
          <p>{{ term.description }}</p>
        </div>
      </div>
    </div>
    <!-- Declaration -->
      <b-form-group v-if="!onboardingDone">
        <div class="checkbox checkbox-custom">
          <input id="faqRead" 
            name="faqRead" 
            type="checkbox" 
            :value="form.documentRead"
            v-model="documentRead"
            @input="handleInput('documentRead', $event.target.checked)"
          >
          <label for="faqRead">I confirm that I have read this document</label>
          <b-alert v-if="$v.form.documentRead.$error" show variant="danger">
            <p>You must tick this box in order to submit the onboarding documents</p>
          </b-alert>
        </div>
      </b-form-group>
      <!-- PDF -->
      <b-form-group label="Get PDF version of preparing for induction">
      <b-button @click="handleGetPDF" variant="primary">Get PDF</b-button>
      </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { updateForm } from '../../helpers/index'
import { sameAs } from 'vuelidate/lib/validators'
import { getPDF } from '../../services/api'
import { fetchManagedContent } from '../../services/api'
export default {
  props: {
    onboardingDone: {
      type: Boolean, 
      default: false,
    }
  },
  computed: {
    ...mapState({form: state => state.authStore.recruit.onboarding.onboardingForms.induction}),
    ...mapGetters({
      getRecruit: 'authStore/getRecruit',
      getToken: 'authStore/getToken',
    })
  },
  data () {
    return {
      documentRead: '',
      formName: 'induction',
      cmCopy: '',
      airportCodes: [
        { 
          title: 'Australia',
          codes: [
            {
              code: 'ADL',
              city: 'Adelaide'
            },
            {
              code: 'BNE',
              city: 'Brisbane'
            },
            {
              code: 'CNS',
              city: 'Cairns'
            },
            {
              code: 'DRW',
              city: 'Darwin'
            },
            {
              code: 'MEL',
              city: 'Melbourne'
            },
            {
              code: 'PER',
              city: 'Perth'
            },
            {
              code: 'SYD',
              city: 'Sydney'
            },
            {
              code: 'ASP',
              city: 'Alice Springs'
            },
            {
              code: 'AYQ',
              city: 'Ayers Rock'
            }
          ]
        },
         { 
          title: 'S.E. Asia',
          codes: [
            {
              code: 'BKK',
              city: 'Bangkok'
            },
            {
              code: 'CGK (JKT)',
              city: 'Jakarta'
            },
            {
              code: 'DPS',
              city: 'Denpasar, Bali'
            },
            {
              code: 'HAN',
              city: 'Hanoi'
            },
            {
              code: 'HKT',
              city: 'Phuket'
            },
            {
              code: 'KUL',
              city: 'Kuala Lumpur'
            },
            {
              code: 'LGK',
              city: 'Langkawi'
            },
            {
              code: 'MNL',
              city: 'Manila'
            },
            {
              code: 'PEN',
              city: 'Penang'
            },
            {
              code: 'SIN',
              city: 'Singapore'
            },
            {
              code: 'SGN',
              city: 'Saigon (Ho Chi Minh City)'
            },
            {
              code: 'USM',
              city: 'Koh Samui'
            }
          ]
        },
         { 
          title: 'New Zealand & Pacific',
          codes: [
            {
              code: 'AKL',
              city: 'Auckland'
            },
            {
              code: 'CHC',
              city: 'Christchurch'
            },
            {
              code: 'ZQN',
              city: 'Queenstown'
            },
            {
              code: 'WLG',
              city: 'Wellington'
            },
            {
              code: 'NAN',
              city: 'Nadi, Fiji'
            },
            {
              code: 'PPT',
              city: 'Papeete, Tahiti'
            },
            {
              code: 'RAR',
              city: 'Raratonga, Cook Islands'
            }
          ]
        },
        { 
          title: 'South Asia',
          codes: [
            {
              code: 'BOM',
              city: 'Bombay - Mumbai'
            },
            {
              code: 'CCU',
              city: 'Culcutta - Kolkata'
            },
            {
              code: 'CMB',
              city: 'Colombo'
            },
            {
              code: 'COK',
              city: 'Cochin'
            },
            {
              code: 'DEL',
              city: 'Delhi'
            },
            {
              code: 'KTM',
              city: 'Kathmandu'
            },
            {
              code: 'MAA',
              city: 'Madras - Chennai'
            },
            {
              code: 'MLE',
              city: 'Male, Maldives'
            },
          ]
        },
        { 
          title: 'Middle East',
          codes: [
            {
              code: 'AMM',
              city: 'Amman'
            },
            {
              code: 'AUH',
              city: 'Abu Dhabi'
            },
            {
              code: 'BAH',
              city: 'Bahrain'
            },
            {
              code: 'CAI',
              city: 'Cairo'
            },
            {
              code: 'DOH',
              city: 'Doha'
            },
            {
              code: 'DXB',
              city: 'Dubai'
            },
            {
              code: 'MCT',
              city: 'Muscat'
            },
          ]
        },
        { 
          title: 'North Asia',
          codes: [
            {
              code: 'PEK (BJS)',
              city: 'Beijing'
            },
            {
              code: 'HKG',
              city: 'Hong Kong'
            },
            {
              code: 'KIX (OSA)',
              city: 'Osaka'
            },
            {
              code: 'ICN (SEL)',
              city: 'Seoul'
            },
            {
              code: 'PVG (SHA)',
              city: 'Shanghai'
            },
            {
              code: 'TPE',
              city: 'Taipei'
            },
            {
              code: 'NRT',
              city: 'Tokyo'
            }
          ]
        },
        { 
          title: 'Europe Cities',
          codes: [
            {
              code: 'ATH',
              city: 'Athens'
            },
            {
              code: 'BCN',
              city: 'Barcelona'
            },
            {
              code: 'BUD',
              city: 'Budapest'
            },
            {
              code: 'CDG / ORY',
              city: 'Paris'
            },
            {
              code: 'DBV',
              city: 'Dubrovnik'
            },
            {
              code: 'FCO (ROM)',
              city: 'Rome'
            },
            {
              code: 'FLR',
              city: 'Florence'
            },
            {
              code: 'KEF',
              city: 'Reykjavik'
            },
            {
              code: 'LIS',
              city: 'Lisbon'
            },
            {
              code: 'MAD',
              city: 'Madrid'
            },
            {
              code: 'NAP',
              city: 'Naples'
            },
            {
              code: 'PRG',
              city: 'Prague'
            },
            {
              code: 'VCE',
              city: 'Venice'
            }
          ]
        },
        { 
          title: 'Europe Beaches',
          codes: [
            {
              code: 'AGP',
              city: 'Malaga'
            },
            {
              code: 'BXN',
              city: 'Bodrun'
            },
            {
              code: 'CHQ',
              city: 'Chania, Crete'
            },
            {
              code: 'FAO',
              city: 'Faro'
            },
            {
              code: 'HER',
              city: 'Heraklion, Crete'
            },
            {
              code: 'JMK',
              city: 'Mykonos'
            },
            {
              code: 'OLB',
              city: 'Olbia, Sardinia'
            },
            {
              code: 'PMI',
              city: 'Mallorca'
            },
            {
              code: 'TFS',
              city: 'Tenerife'
            }
          ]
        },
         { 
          title: 'Africa',
          codes: [
            {
              code: 'ACC',
              city: 'Accra'
            },
            {
              code: 'ADD',
              city: 'Addis Ababa'
            },
            {
              code: 'CPT',
              city: 'Cape Town'
            },
            {
              code: 'DAR',
              city: 'Dar es Salaam'
            },
            {
              code: 'HRE',
              city: 'Harare'
            },
            {
              code: 'JNB',
              city: 'Johannesburg'
            },
            {
              code: 'LOS',
              city: 'Lagos'
            },
            {
              code: 'LLW',
              city: 'Lilongwe'
            },
            {
              code: 'LUN',
              city: 'Lusaka'
            },
            {
              code: 'MRU',
              city: 'Mauritius'
            },
            {
              code: 'NBO',
              city: 'Nairobi'
            },
            {
              code: 'RAK',
              city: 'Marrakech'
            },
            {
              code: 'SEZ',
              city: 'Seychelles'
            },
            {
              code: 'WDH',
              city: 'Windhoek'
            }
          ]
        },
        { 
          title: 'C. America',
          codes: [
            {
              code: 'CUN',
              city: 'Cancun'
            },
            {
              code: 'BZE',
              city: 'Belize City'
            },
            {
              code: 'GUA',
              city: 'Guatemala City'
            },
            {
              code: 'MEX',
              city: 'Mexico City'
            },
            {
              code: 'PTY',
              city: 'Panama City'
            },
            {
              code: 'SJO',
              city: 'San Jose'
            }
          ]
        },
        { 
          title: 'Caribbean',
          codes: [
            {
              code: 'ANU',
              city: 'Antigua'
            },
            {
              code: 'BGI',
              city: 'Barbados'
            },
            {
              code: 'HAV',
              city: 'Havana'
            },
            {
              code: 'KIN',
              city: 'Kingston'
            },
            {
              code: 'MBJ',
              city: 'Montego Bay'
            },
            {
              code: 'NAS',
              city: 'Nassau'
            },
            {
              code: 'POS',
              city: 'Trinidad'
            },
            {
              code: 'UVF (SLU)',
              city: 'St Lucia'
            },
            {
              code: 'TAB',
              city: 'Tobago'
            }
          ]
        },
        { 
          title: 'N. America',
          codes: [
            {
              code: 'ATL',
              city: 'Atlanta'
            },
            {
              code: 'BOS',
              city: 'Boston'
            },
            {
              code: 'ORD (CHI)',
              city: 'Chicago'
            },
            {
              code: 'CLT',
              city: 'Charlotte'
            },
            {
              code: 'DEN',
              city: 'Denver'
            },
            {
              code: 'DFW',
              city: 'Dallas'
            },
            {
              code: 'DTW',
              city: 'Detroit'
            },
            {
              code: 'IAH (HOU)',
              city: 'Houston'
            },
            {
              code: 'LAX',
              city: 'Los Angeles'
            },
            {
              code: 'LAS',
              city: 'Las Vegas'
            },
            {
              code: 'MIA',
              city: 'Miami'
            },
            {
              code: 'MSY',
              city: 'New Orleans'
            },
            {
              code: 'JFK/EWR (NYC)',
              city: 'New York'
            },
            {
              code: 'MCO (ORL)',
              city: 'Orlando'
            },
            {
              code: 'PHL',
              city: 'Philadelphia'
            },
            {
              code: 'PHX',
              city: 'Phoenix'
            },
            {
              code: 'SAN',
              city: 'San Diego'
            },
            {
              code: 'SEA',
              city: 'Seattle'
            },
            {
              code: 'SFO',
              city: 'San Francisco'
            },
            {
              code: 'TPA',
              city: 'Tampa'
            },
            {
              code: 'IAD (WAS)',
              city: 'Washington'
            }
          ]
        },
        { 
          title: 'S. America',
          codes: [
            {
              code: 'EZE (BUE)',
              city: 'Buenos Aires'
            },
            {
              code: 'CCS',
              city: 'Caracas'
            },
            {
              code: 'CUZ',
              city: 'Cuzco'
            },
            {
              code: 'LPB',
              city: 'La Paz'
            },
            {
              code: 'LIM',
              city: 'Lima'
            },
            {
              code: 'GIG (RIO)',
              city: 'Rio de Janeiro'
            },
            {
              code: 'GRU (SAO)',
              city: 'Sao Paulo'
            },
            {
              code: 'SCL',
              city: 'Santiago'
            },
            {
              code: 'UIO',
              city: 'Quito'
            }
          ]
        },
        { 
          title: 'Canada',
          codes: [
            {
              code: 'YUL (YMQ)',
              city: 'Montreal'
            },
            {
              code: 'YYZ (YTO)',
              city: 'Toronto'
            },
            {
              code: 'YVR',
              city: 'Vancouver'
            },
            {
              code: 'YYC',
              city: 'Calgary'
            },
            {
              code: 'YOW',
              city: 'Ottawa'
            },
          ]
        }
      ],
      airlineCodes: [
        { code: 'AA', airline: 'American Airlines*' },
        { code: 'AC', airline: 'Air Canada (YYZ)' },
        { code: 'AF', airline: 'Air France (CDG)' },
        { code: 'AI', airline: 'Air India (BOM/DEL)' },
        { code: 'AR', airline: 'Aerolineas Argentinas (EZE/AEP)' },
        { code: 'AY', airline: 'Finnair (HEL)' },
        { code: 'AZ', airline: 'Alitalia (FCO)' },
        { code: 'BA', airline: 'British Airways (LHR/LGW)' },
        { code: 'BE', airline: 'Flybe (UK airports)' },
        { code: 'BI', airline: 'Royal Brunei Airlines' },
        { code: 'BR', airline: 'Eva Airways (TPE)' },
        { code: 'CA', airline: 'Air China (PEK)' },
        { code: 'CI', airline: 'China Airlines (TPE)' },
        { code: 'CX', airline: 'Cathay Pacific Airways (HKG)' },
        { code: 'CZ', airline: 'China Southern (CAN)' },
        { code: 'DL', airline: 'Delta Airlines*' },
        { code: 'EI', airline: 'Aer Lingus (DUB)' },
        { code: 'EK', airline: 'Emirates (DXB)' },
        { code: 'EY', airline: 'Etihad (AUH)' },
        { code: 'FI', airline: 'Icelandair (KEF)' },
        { code: 'FJ', airline: 'Fiji Airways (NAN)' },
        { code: 'GA', airline: 'Garuda Indonesia (CGK)' },
        { code: 'GF', airline: 'Gulf Air (BAH)' },
        { code: 'HM', airline: 'Air Seychelles (SEZ)' },
        { code: 'IB', airline: 'Iberia (MAD)' },
        { code: 'JL', airline: 'Japan Airlines (NRT/OSA)' },
        { code: 'JQ', airline: 'Jetstar (Australian Airports)' },
        { code: 'KE', airline: 'Korean Air (SEL)' },
        { code: 'KL', airline: 'KLM Royal Dutch Airlines (AMS)' },
        { code: 'KM', airline: 'Air Malta (MLA)' },
        { code: 'KQ', airline: 'Kenya Airways (NBO)' },
        { code: 'LA', airline: 'LATAM Airlines (SCL)' },
        { code: 'LH', airline: 'Lufthansa (FRA/MUC)' },
        { code: 'LS', airline: 'Jet2 (UK airports)' },
        { code: 'MH', airline: 'Malaysian Airlines (KUL)' },
        { code: 'MI', airline: 'Silk Air (SIN)' },
        { code: 'MK', airline: 'Air Mauritius (MRU)' },
        { code: 'MS', airline: 'Egyptair (CAI)' },
        { code: 'MU', airline: 'China Eastern Airlines (PVG)' },
        { code: 'NZ', airline: 'Air New Zealand (AKL)' },
        { code: 'OK', airline: 'Czech Airlines (PRG)' },
        { code: 'OZ', airline: 'Asiana Airlines (ICN)' },
        { code: 'PG', airline: 'Bankkok Airways (BKK)' },
        { code: 'PR', airline: 'Philippine Airlines (MNL)' },
        { code: 'QF', airline: 'Qantas Airways (SYD)' },
        { code: 'QR', airline: 'Qatar Airways (DOH)' },
        { code: 'RJ', airline: 'Royal Jordanian (AMM)' },
        { code: 'SA', airline: 'South African Airways (JNB)' },
        { code: 'SG', airline: 'Spicejet (Indian airports)' },
        { code: 'SK', airline: 'Scandanavian Airlines (CPH/STO)' },
        { code: 'SQ', airline: 'Singapore Airlines (SIN)' },
        { code: 'SN', airline: 'Brussels Airlines (BRU)' },
        { code: 'TG', airline: 'Thai Airways International (BKK)' },
        { code: 'TK', airline: 'Turkish Airlines (IST)' },
        { code: 'TP', airline: 'TAP Air Portugal (LIS)' },
        { code: 'TR', airline: 'Scoot Tiger Airways (SIN)' },
        { code: 'UA', airline: 'United Airlines*' },
        { code: 'UL', airline: 'Sri Lankan Airlines (CMB)' },
        { code: 'UX', airline: 'Air Europa (MAD)' },
        { code: 'U2', airline: 'Easyjet (UK airports)' },
        { code: 'VA', airline: 'Virgin Australia (Australian airports)' },
        { code: 'VN', airline: 'Vietnam Airlines (HAN/SGN)' },
        { code: 'VS', airline: 'Virgin Atlantic (LHR/LGW)' },
        { code: 'VY', airline: 'Vueling Airlines (BCN)' },
        { code: 'WY', airline: 'Oman Air (MCT)' },
        { code: '6E', airline: 'IndiGo (Indian airports' }
      ],
      phonetic: [
        { code: 'ALPHA' },
        { code: 'BRAVO' },
        { code: 'CHARLIE' },
        { code: 'DELTA' },
        { code: 'ECHO' },
        { code: 'FOXTROT' },
        { code: 'GOLD' },
        { code: 'HOTEL' },
        { code: 'INDIA' },
        { code: 'JULIET' },
        { code: 'KILO' },
        { code: 'LIMA' },
        { code: 'MIKE' },
        { code: 'NOVEMBER' },
        { code: 'OSCAR' },
        { code: 'PAPA' },
        { code: 'QUEBEC' },
        { code: 'ROMEO' },
        { code: 'SIERRA' },
        { code: 'TANGO' },
        { code: 'UNIFORM' },
        { code: 'VICTOR' },
        { code: 'WHISKEY' },
        { code: 'XRAY' },
        { code: 'YANKEE' },
        { code: 'ZULU' }
      ],
      glossary: [
        { term: 'IATA', description: 'International Air Transport Association' },
        { term: 'ATOL', description: 'Air Travel Organisers Licence' },
        { term: 'CAA', description: 'Civil Aviation Authority' },
        { term: 'GATEWAY CITY', description: 'International point of entry to a country' },
        { term: 'HUB CITY', description: 'City in which an airline is based' },
        { term: 'IN/OUT FEEDER', description: 'Connecting flight into or out of a hub city' },
        { term: 'DIRECT FLIGHT', description: '1 plane, 1 flight number (not necessarily non-stop)' },
        { term: 'TRANSIT/TRANSFER', description: 'Change of planes enroute to a further destination' },
        { term: 'TOUCHDOWN', description: 'Direct flights can touchdown to refuel (no change)' },
        { term: 'STOPOVER', description: 'Stop for 24hrs + enroute to a further destination' },
        { term: 'OPEN JAW', description: 'A return ticket that flies into one city and back from another' },
        { term: 'SURFACE SECTOR', description: 'Overland travel between two points' },
        { term: 'P.O.T.', description: 'Point of turnaround, (furthest point on itinerary)' },
        { term: 'CODESHARE', description: 'Flight operated by different carrier to flight number given (eg flight QF8414 operated by EK)' },
        { term: 'MCT', description: 'Minimum connection time (minimum transit time)' }
      ]
    }
  },
  mounted () {
    this.$v.$touch()
    this.getCMCopy()
    setTimeout(() => {
      this.documentRead = this.form.documentRead
    }, 1000)
  },
  updated () {
    // this.updateForm('valid', this.$v.$error)
    const validationData = {
      section: 'induction',
      status: !this.$v.form.$invalid
    }
    this.updateOnboardingCompleteAction(validationData)
  },
  methods: {
    ...mapActions({
      updateOnboardingFormAction: 'authStore/updateOnboardingFormAction',
      currentOnboardingFormAction: 'authStore/currentOnboardingFormAction',
      setRecruitAction: 'authStore/setRecruitAction',
      updateOnboardingCompleteAction: 'authStore/updateOnboardingCompleteAction'
    }),
    handleInput(input, e, nested, array, index, item) {
      this.updateForm(input, e, nested, array, index, item)
    },
    async getCMCopy() {
      let res = await fetchManagedContent(this.getToken,3)
      if (res && res.data) {
        this.cmCopy = res.data
      } 
    },
    async handleGetPDF () {
      const pdfData = {
        form: 'induction',
        data: ''
      }
      const res = await getPDF(pdfData)
      const file = new Blob([res.data], { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL, '_blank')
    },
    updateForm
  },
  validations: {
    form: {
      documentRead: {
        sameAs: sameAs(() => true)
      }
    }
  }
}
</script>

<style scoped>
.induction-group {
  width: 100%;
  margin: 3rem 0;
}
.airport-codes {
  display: grid;
  grid-template-columns: repeat(1fr);
}
.airport-codes-alt {
  display: grid;
  grid-template-columns: repeat(1fr);
}
.airport-codes-item {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.glossary {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
@media only screen and (min-width: 550px) {
  .airport-codes-alt {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (min-width: 750px) {
  .airport-codes-alt {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (min-width: 992px) {
  .airport-codes {
    grid-template-columns: repeat(2, 1fr);
  }
  .airport-codes-alt {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>